import React, { useContext, useEffect } from 'react';
import { ModalContent } from './library/Modal';
import { StateContext, actions } from "../state";
import { BROWSER_STORAGE_ITEMS } from "../utils/enums";
import moment from 'moment';

const hashString = str => {
  let hash = 0, letter;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    letter = str.charCodeAt(i);
    hash  = ((hash << 5) - hash) + letter;
    hash |= 0; // Convert to 32bit integer
  }

  return hash.toString();
};

class Notification {
  constructor(notification, dispatch) {
    this.title = notification.title || 'System Notification';
    this.message = notification.message;
    this.showFaqLink = notification.showFaqLink || false;
    this.suppressionDurationInMinutes = notification.suppressionDurationInMinutes;
    this.id = hashString(notification.message);
    this.dispatch = dispatch;

    if(this.shouldBeDisplayed()){
      this.showNotification();
    }
  }

  showNotification() {
    this.dispatch(actions.modals.pushModal(<ModalContent
      description={this.message}
      showFaqLink={this.showFaqLink}
      onClose={() => this.hideNotification()}
    />, {className: 'system-notification', title: this.title, showFaqLink: this.showFaqLink}))
  }

  hideNotification() {
    let notifications = window.localStorage.getItem(BROWSER_STORAGE_ITEMS.SEEN_SYSTEM_NOTIFICATIONS) || "{}";
    notifications = JSON.parse(notifications);
    notifications[this.id] = { lastSeen: moment().toISOString(), message: this.message };
    window.localStorage.setItem(BROWSER_STORAGE_ITEMS.SEEN_SYSTEM_NOTIFICATIONS, JSON.stringify(notifications));
  }
}

Notification.prototype.shouldBeDisplayed = function(){
  let notifications = window.localStorage.getItem(BROWSER_STORAGE_ITEMS.SEEN_SYSTEM_NOTIFICATIONS);

  if(!notifications) {
    return true;
  }

  notifications = JSON.parse(notifications);

  if(!notifications[this.id]) {
    return true;
  }

  let { lastSeen } = notifications[this.id];
  if(!lastSeen) return true;

  lastSeen = moment(lastSeen);
  const now = moment();
  return now.isAfter(lastSeen.add(this.suppressionDurationInMinutes, 'minutes'));
};

export const SystemNotifications = () => {
  const [{configuration: {systemNotifications}, renderId}, dispatch] = useContext(StateContext);

  useEffect(() => {
    let { notifications, enabled, suppressSeenNotificationDurationInMinutes } = systemNotifications;

    if(!enabled || !notifications || !notifications.length) {
      return;
    }

    [...notifications].reverse().forEach(notification => new Notification({...notification, supressionDurationInMinutes: notification.suppressSeenNotificationDurationInMinutes || suppressSeenNotificationDurationInMinutes}, dispatch));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderId]);

  return null;
};

export default SystemNotifications;
